module.exports = __webpack_public_path__ + "img/s2P14.7d77a0d9.png";